// tslint:disable
import {get} from 'lodash';
import * as React from 'react';
import {InputField} from '../../components/fields/input.field';
import {ConsoleLib} from '../../components/libs/console.lib';
import {ListResourceLoader} from '../../components/libs/list-resource-loader';
import {ListLib} from '../../components/libs/list.lib';
import {ListConsole} from '../../components/structurals/list-console';
import {LoaderComponent} from '../../components/structurals/loader.component';
import {Pagination} from '../../components/structurals/pagination';
import {
    ListActions,
    ListResponsePresenterTable
} from '../../components/structurals/presenters/list-response-presenter-table';
import * as moment from 'moment';
import {IriPresenter} from "../../components/structurals/presenters/iri-presenter";
import {IriField} from "../../components/fields/iri.field";

export class DefaultBookingList extends React.Component<any, any> {

    async handleItemDelete(item: any, list: ListLib, listActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        list.isLoading$.next(true);
        await listActions.delete(item['@id']);
        list.refetch();
    }

    render() {
        return (
            <ListResourceLoader forceQuery={{'order[id]': 'DESC'}} entity="booking" render={(list: ListLib) => <div>
                <div id="page-title">
                    <h2>
                        Bookings
                        <div className="pull-right">
                            <a href="/booking/create" className='btn btn-sm btn-primary'>Create new booking</a>
                        </div>
                    </h2>
                    <p>Lorem</p>
                </div>

                <ListConsole
                    className="col-xs-12 col-md-3 pull-right"
                    config={list.console}
                    render={(console: ConsoleLib) => <div>
                        <InputField field={console.setQuery('title', {
                            title: 'Search in event name',
                            placeholder: 'some keyword'
                        })}/>

                        <IriField
                            field={console.setQuery('destination', {title: 'Destination', iri: 'country'})}
                            defaultAll={true}
                            itemRender={(item: any) => item.title}
                        />
                        <IriField
                            field={console.setQuery('person', {title: 'Person', iri: 'person'})}
                            defaultAll={true}
                            itemRender={(item: any) => `${item.firstName} ${item.surName}`}
                        />
                    </div>}
                />

                <div className="col-xs-12 col-md-9 pull-left relative">
                    <LoaderComponent isLoading$={list.isLoading$}/>

                    <ListResponsePresenterTable
                        items={list.member}
                        head={() => {
                            return (
                                <tr>
                                    <th>#</th>
                                    <th>Booking date</th>
                                    <th>Travel date</th>
                                    <th>Adults num.</th>
                                    <th>Children num.</th>
                                    <th>Booking Value</th>
                                    <th>Destination</th>
                                    <th>Person</th>
                                    <th></th>
                                </tr>
                            );
                        }}
                        row={(item: any, index: number, actions: ListActions) => {
                            return (
                                <tr key={index}>
                                    <td>{get(item, 'id', '-')}</td>
                                    <td>
                                        {moment(get(item, 'bookingDate')).format('DD/MM/Y H:mm')}
                                    </td>
                                    <td>
                                        {moment(get(item, 'travelDate')).format('DD/MM/Y H:mm')}
                                    </td>
                                    <td>
                                        {get(item, 'adultsNumber')}
                                    </td>
                                    <td>
                                        {get(item, 'childrenNumber')}
                                    </td>
                                    <td>
                                        £ {get(item, 'bookingValue').toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                    </td>
                                    <td>
                                        <IriPresenter
                                            iri={get(item, 'destination.@id')}
                                            path="title"
                                        />
                                    </td>
                                    <td>
                                        <IriPresenter iri={get(item, 'person.@id')} render={(person: any) =>
                                            `${get(person, 'firstName')} ${get(person, 'surName')}`
                                        }/>
                                    </td>
                                    <td>
                                        <button className="btn btn-xs btn-primary"
                                                onClick={() => actions.open(item['@id'])}>View details
                                        </button>
                                    </td>
                                </tr>
                            );
                        }}/>

                    <Pagination config={list.pagination}/>
                </div>
            </div>}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/lists/default.booking.list.tsx